"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VAlert_vue_1 = __importDefault(require("../scraps/VAlert.vue"));
var VModal_vue_1 = __importDefault(require("../scraps/VModal.vue"));
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var RoleNameInput_vue_1 = __importDefault(require("../form/RoleNameInput.vue"));
var errors_1 = __importDefault(require("../../config/errors"));
exports.default = vue_1.default.extend({
    name: "create-role-modal",
    components: {
        VAlert: VAlert_vue_1.default,
        VButton: VButton_vue_1.default,
        VModal: VModal_vue_1.default,
        RoleNameInput: RoleNameInput_vue_1.default
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            roleName: "",
            invalidRoleName: false,
            errors: errors_1.default
        };
    },
    methods: {
        onKeyDown: function (keyCode) {
            if (keyCode === 13) {
                this.onCreateRole();
            }
        },
        onClose: function () {
            this.invalidRoleName = false;
            this.roleName = "";
            this.$emit("close");
        },
        onCreateRole: function () {
            if (!this.$refs["roleNameInput"].isValid(true)) {
                this.$refs["roleNameInput"].appendValidationClass();
                return;
            }
            this.$emit("createRole", this.roleName);
            this.roleName = "";
        }
    }
});
